import {
  Article as ArticleIcon,
  Timeline as TimelineIcon,
  Payments as PaymentsIcon,
  BeachAccess as BeachAccessIcon,
  AccountTree as AccountTreeIcon,
  WorkOutline as WorkOutlineIcon,
  Folder as FolderIcon,
  AccountBalance as AccountBalanceIcon,
  Notes as NotesIcon,
  EventBusy as EventBusyIcon,
} from '@mui/icons-material';
import theme from '../../../theme/theme';
import type { SectionVisual } from '../../../components/ui/sectionCard/types';

export type ContractSectionKey =
  | 'contract_info'
  | 'seniority'
  | 'remuneration'
  | 'leave'
  | 'manager'
  | 'position'
  | 'contract_docs'
  | 'funding'
  | 'contract_comment'
  | 'contract_end';

export const CONTRACT_HISTORY_VISUAL: SectionVisual = { iconBg: '#f1f5f9', iconColor: '#475569' };

export const CONTRACT_SECTION_VISUAL: Record<ContractSectionKey, SectionVisual> = {
  contract_info:    { iconBg: '#fef3c7', iconColor: '#d97706' },
  seniority:        { iconBg: '#ccfbf1', iconColor: '#0f766e' },
  remuneration:     { iconBg: '#bbf7d0', iconColor: '#15803d' },
  leave:            { iconBg: '#e0f2fe', iconColor: '#0284c7' },
  manager:          { iconBg: '#e0e7ff', iconColor: '#4338ca' },
  position:         { iconBg: '#f3e8ff', iconColor: '#7c3aed' },
  contract_docs:    { iconBg: '#f1f5f9', iconColor: '#475569' },
  funding:          { iconBg: '#cffafe', iconColor: '#0891b2' },
  contract_comment: { iconBg: '#fce7f3', iconColor: '#be185d' },
  contract_end:     { iconBg: '#fee2e2', iconColor: '#dc2626' },
};

export const CONTRACT_SECTION_ICON: Record<
  ContractSectionKey,
  (color: string) => ReturnType<typeof ArticleIcon>
> = {
  contract_info:    c => <ArticleIcon        sx={{ fontSize: theme.iconSize.sm, color: c }} />,
  seniority:        c => <TimelineIcon       sx={{ fontSize: theme.iconSize.sm, color: c }} />,
  remuneration:     c => <PaymentsIcon       sx={{ fontSize: theme.iconSize.sm, color: c }} />,
  leave:            c => <BeachAccessIcon    sx={{ fontSize: theme.iconSize.sm, color: c }} />,
  manager:          c => <AccountTreeIcon    sx={{ fontSize: theme.iconSize.sm, color: c }} />,
  position:         c => <WorkOutlineIcon    sx={{ fontSize: theme.iconSize.sm, color: c }} />,
  contract_docs:    c => <FolderIcon         sx={{ fontSize: theme.iconSize.sm, color: c }} />,
  funding:          c => <AccountBalanceIcon sx={{ fontSize: theme.iconSize.sm, color: c }} />,
  contract_comment: c => <NotesIcon          sx={{ fontSize: theme.iconSize.sm, color: c }} />,
  contract_end:     c => <EventBusyIcon      sx={{ fontSize: theme.iconSize.sm, color: c }} />,
};
